const fromNcobSettingsToDto = (item) =>
  !item
    ? item
    : {
        online_booking: item.onlineBooking,
        ncob_mode: item.ncobMode,
        check_ncob_availability_until: item.checkNcobAvailabilityUntil,
        closest_booking_time: item.closestBookingTime,
        use_ncob_smart_alg: item.useNcobSmartAlg,
        book_ncob_with_same: item.bookNcobWithSame,
        salon_ncob_text: item.salonNcobText,
        salon_ncob_info: item.salonNcobInfo,
        ncob_cancel_window: item.ncobCancelWindow,
        salon_ncob_email: item.salonNcobEmail,
        salon_stripe_account_status: item.salonStripeAccountStatus,
        group_ncob_tiny_url: item.groupNcobTinyUrl,
        ncob_tiny_url: item.ncobTinyUrl,
        booking_timings: item.bookingTimings,
        profile_image_url: item.profileImageUrl,
        profile_image: item.profileImage,
        send_ncob_email_to_stylists: item.sendNcobEmailToStylists,
        ncob_deposit_settings: item.ncobDepositSettings,
        ncob_custom_amount: item.ncobCustomAmount,
        no_show_protection: item.noShowProtection,
        has_ncob_stripe_account: item.hasNcobStripeAccount,
        can_take_voucher_payments: item.canTakeVoucherPayments,
        ncob_welcome_message: item.salonNcobWelcomeMessage,
        ncob_patch_test_copy: item.salonNcobPatchTestCopy,
        prevent_patch_test_from_overlapping_appointment: item.preventPatchTestFromOverlappingAppointment,
      };

export default fromNcobSettingsToDto;
